import React from 'react';
import PropTypes from 'prop-types';

export default function GrassStatusIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 22 18" fill={color} {...rest}>
      <path
        d="M18.3848 17.7787C18.9531 17.7787 19.4928 17.5626 19.9045 17.17L21.9878 15.182L22 0.179932H3.60312C3.03446 0.179932 2.49476 0.39613 2.08343 0.788699L0 2.77661V17.7853L18.3848 17.7787ZM20.5202 11.1868V11.8374H17.5844V6.12733H20.5259L20.5202 11.1868ZM20.5309 1.64751L20.5275 4.65975H16.1168V13.3049H20.5202V14.5539L18.8916 16.1081C18.7542 16.2391 18.5743 16.3111 18.3848 16.3111L11.7303 16.3111L11.7158 11.913H12.0266C12.1463 11.913 12.261 11.8654 12.3458 11.7807L13.798 10.3285C13.8827 10.2438 13.9302 10.129 13.9302 10.0093V7.9554C13.9302 7.83572 13.8827 7.72088 13.798 7.6362L12.3458 6.18395C12.261 6.09928 12.1463 6.05173 12.0266 6.05173H11.731L11.7165 1.64751H20.5309ZM11.6056 7.51931L12.4626 8.3763V9.58837L11.6056 10.4454H10.3937L9.53653 9.58837V8.3763L10.3937 7.51931H11.6056ZM1.46758 6.12733H4.37619V11.8374H1.46758V6.12733ZM1.46758 16.3167V13.3049H5.84377V4.65975H1.46758V3.40475L3.09656 1.85038C3.2337 1.71954 3.41353 1.64751 3.60312 1.64751H10.2489L10.2634 6.05173H9.97267C9.85303 6.05173 9.73808 6.09928 9.65349 6.18395L8.20124 7.6362C8.11664 7.72088 8.06901 7.83572 8.06901 7.9554V10.0093C8.06901 10.129 8.11664 10.2438 8.20124 10.3285L9.65349 11.7807C9.73808 11.8654 9.85303 11.913 9.97267 11.913H10.2482L10.2627 16.3111L1.46758 16.3167Z"
        fill="#00001B"
      />
    </svg>
  );
}

GrassStatusIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

GrassStatusIcon.defaultProps = {
  size: 25,
  color: '#000',
};
